// extracted by mini-css-extract-plugin
export default {"products":"Products_products__LZgII","searchInput":"Products_searchInput__8WBmt"};